(() => {
  'use strict';
  const root = document.querySelector('[data-rv-product-root]');
  if (!root) return;
  const form = document.querySelector('#rv-product-form');
  const quantityField = document.querySelector('#rv-form-quantity');
  const currency = root.dataset.currency || 'USD';
  const money = cents => {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style: 'currency', currency}).format(cents / 100); }
    catch (_) { return (cents / 100).toFixed(2); }
  };
  let variants = [];
  try { variants = JSON.parse(document.querySelector('#rv-variant-json')?.textContent || '[]'); } catch (_) { /* Nothing configured */ }
  const variantFor = id => variants.find(v => String(v.id) === String(id)) || variants[0];
  const slotSelectors = [...document.querySelectorAll('[data-rv-slot]')];
  const baseId = document.querySelector('#rv-variant-select')?.value;
  let currentQuantity = 3;
  const getVariants = qty => Array.from({ length: qty }, (_, index) => variantFor(slotSelectors[index]?.value || baseId)).filter(Boolean);
  const giftCount = qty => qty === 3 ? 1 : qty === 5 ? 2 : 0;
  const totalFor = qty => {
    const list = getVariants(qty);
    if (list.length !== qty) return null;
    const gross = list.reduce((sum, v) => sum + Number(v.price), 0);
    // Shopify Buy X Get Y applies to the lowest-priced eligible products.
    const cheapest = list.map(v => Number(v.price)).sort((a,b) => a-b);
    const discount = cheapest.slice(0, giftCount(qty)).reduce((sum, price) => sum + price, 0);
    return { gross, discount, net: gross - discount };
  };
  const recalc = () => {
    const chosen = getVariants(currentQuantity);
    const single = chosen[0] || variantFor(baseId);
    if (!single) return;
    const mainUnit = document.querySelector('#rv-main-unit-price');
    if (mainUnit) mainUnit.textContent = money(Number(single.price));
    const compare = document.querySelector('#rv-main-compare');
    if (compare) { compare.hidden = !(single.compare_at_price > single.price); compare.textContent = single.compare_at_price > single.price ? money(Number(single.compare_at_price)) : ''; }
    document.querySelectorAll('[data-price-qty]').forEach(el => {
      const qty = Number(el.dataset.priceQty);
      const t = totalFor(qty);
      if (t) el.textContent = money(t.net);
      const save = document.querySelector(`[data-rv-saving="${qty}"]`);
      if (save && t) save.textContent = `Save ${money(t.discount)}`;
    });
    const valid = chosen.length === currentQuantity && chosen.every(v => v.available);
    const button = document.querySelector('#rv-add-button');
    if (button) button.disabled = !valid;
    const label = document.querySelector('#rv-add-label');
    if (label) label.textContent = valid ? `ADD ${currentQuantity} MUG${currentQuantity > 1 ? 'S' : ''} TO CART` : 'SOLD OUT';
  };
  const chooseBundle = qty => {
    const desired = Number(qty);
    if (![1,3,5].includes(desired)) return;
    currentQuantity = desired;
    if (quantityField) quantityField.value = desired;
    document.querySelectorAll('.rv-bundle').forEach(el => {
      const active = Number(el.dataset.qty) === currentQuantity;
      el.classList.toggle('is-selected', active);
      const radio = el.querySelector('input[type="radio"]');
      if (radio) radio.checked = active;
    });
    document.querySelectorAll('[data-rv-slot-wrapper]').forEach(el => { el.hidden = Number(el.dataset.rvSlotWrapper) > currentQuantity; });
    const summary = document.querySelector('#rv-gift-summary');
    const heading = document.querySelector('#rv-gift-summary-heading');
    const caption = document.querySelector('#rv-gift-summary-caption');
    if (summary) summary.dataset.qty = String(desired);
    if (heading && caption) {
      if (desired === 1) { heading.textContent = 'Your single smart mug'; caption.textContent = '1 mug in your cart. No free extras in this option.'; }
      if (desired === 3) { heading.textContent = '🎁 1 FREE mug included!'; caption.textContent = 'You pay for 2 mugs and receive 3 total.'; }
      if (desired === 5) { heading.textContent = '🎁🎁 2 FREE mugs included!'; caption.textContent = 'You pay for 3 mugs and receive 5 total.'; }
    }
    recalc();
  };
  document.querySelectorAll('.rv-bundle').forEach(el => {
    const radio = el.querySelector('input[type="radio"]');
    el.addEventListener('click', () => chooseBundle(el.dataset.qty));
    el.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); chooseBundle(el.dataset.qty); } });
  });
  slotSelectors.forEach(el => el.addEventListener('change', recalc));
  document.querySelectorAll('.rv-thumb').forEach(btn => btn.addEventListener('click', () => {
    const main = document.querySelector('#rv-main-image');
    if (!main) return;
    main.src = btn.dataset.gallerySrc;
    main.alt = btn.dataset.galleryAlt || 'Rivellor mug';
    document.querySelectorAll('.rv-thumb').forEach(other => other.classList.toggle('is-current', other === btn));
  }));
  document.querySelectorAll('[data-scroll-bundles]').forEach(el => el.addEventListener('click', () => document.querySelector('.rv-bundle-shell')?.scrollIntoView({behavior:'smooth',block:'center'})));
  const timer = document.querySelector('#rv-sale-timer');
  if (timer && root.dataset.saleEnd) {
    const deadline = Date.parse(root.dataset.saleEnd);
    const update = () => {
      const seconds = Math.max(0, Math.floor((deadline - Date.now()) / 1000));
      if (!Number.isFinite(deadline) || seconds <= 0) { timer.hidden = true; return false; }
      const days = Math.floor(seconds / 86400), hours = Math.floor(seconds % 86400 / 3600), minutes = Math.floor(seconds % 3600 / 60), secs = seconds % 60;
      const txt = (days ? `${days}d ` : '') + [hours,minutes,secs].map(n=>String(n).padStart(2,'0')).join(':');
      timer.hidden = false;
      document.querySelector('#rv-timer-display').textContent = txt;
      return true;
    };
    if (update()) { const interval = window.setInterval(() => { if (!update()) window.clearInterval(interval); }, 1000); }
  }
  if (form) form.addEventListener('submit', async e => {
    e.preventDefault();
    const chosen = getVariants(currentQuantity);
    const message = document.querySelector('#rv-cart-message');
    const btn = document.querySelector('#rv-add-button');
    if (chosen.length !== currentQuantity || chosen.some(v => !v.available)) { if (message) message.textContent = 'Please choose available mug options.'; return; }
    const grouped = new Map();
    chosen.forEach(v => { const id = Number(v.id); grouped.set(id, (grouped.get(id) || 0) + 1); });
    const items = [...grouped].map(([id,quantity]) => ({id,quantity}));
    const addon = document.querySelector('#rv-addon-toggle');
    if (addon?.checked && addon.value) items.push({id:Number(addon.value),quantity:1});
    if (btn) btn.disabled = true;
    if (message) message.textContent = 'Adding your mugs…';
    const rootPath = window.Shopify?.routes?.root || '/';
    try {
      const res = await fetch(`${rootPath}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify({items})});
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Unable to add your mugs.');
      window.location.assign(`${rootPath}cart`);
    } catch (error) {
      if (message) message.textContent = error.message || 'Sorry, please try again.';
      if (btn) btn.disabled = false;
    }
  });
  chooseBundle(3);
})();
